export default __webpack_public_path__ + "static/media/flag-puerto-rico.25d8c653.svg";